import { size } from '../../size.mjs';

var font = {
  'font-family-sans': {
    value: "'Inter', -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif"
  },
  'font-family-mono': {
    value: "ui-monospace, SFMono-Regular, 'SF Mono', Consolas, 'Liberation Mono', Menlo, monospace"
  },
  'font-size-275': {
    value: size[275]
  },
  'font-size-300': {
    value: size[300]
  },
  'font-size-325': {
    value: size[325]
  },
  'font-size-350': {
    value: size[350]
  },
  'font-size-400': {
    value: size[400]
  },
  'font-size-450': {
    value: size[450]
  },
  'font-size-500': {
    value: size[500]
  },
  'font-size-550': {
    value: size[550]
  },
  'font-size-600': {
    value: size[600]
  },
  'font-size-750': {
    value: size[750]
  },
  'font-size-800': {
    value: size[800]
  },
  'font-size-900': {
    value: size[900]
  },
  'font-size-1000': {
    value: size[1000]
  },
  'font-weight-regular': {
    value: '450'
  },
  'font-weight-medium': {
    value: '550'
  },
  'font-weight-semibold': {
    value: '650'
  },
  'font-weight-bold': {
    value: '700'
  },
  'font-letter-spacing-densest': {
    value: '-0.54px'
  },
  'font-letter-spacing-denser': {
    value: '-0.3px'
  },
  'font-letter-spacing-dense': {
    value: '-0.2px'
  },
  'font-letter-spacing-normal': {
    value: '0px'
  },
  'font-line-height-300': {
    value: size[300]
  },
  'font-line-height-400': {
    value: size[400]
  },
  'font-line-height-500': {
    value: size[500]
  },
  'font-line-height-600': {
    value: size[600]
  },
  'font-line-height-700': {
    value: size[700]
  },
  'font-line-height-800': {
    value: size[800]
  },
  'font-line-height-1000': {
    value: size[1000]
  },
  'font-line-height-1200': {
    value: size[1200]
  }
};

export { font };
